import { useEffect, useState } from "react";
import * as microsoftTeams from "@microsoft/teams-js";
import { jwtDecode } from "jwt-decode";
import { MessagePopup } from "../MessagePopup/messagePopup";
import "./FeedbackAppTab.css";
import FeedbackAppTabConfig from "./feedbackAppTabConfig";
import { Msgdetails } from "./_models/msgdetails-model";
import { FeedbackAppTabRemove } from "./FeedbackAppTabRemove";
import InMeetingNew1Tab from "../InMeetingNew1Tab/InMeetingNew1Tab";
import MeetingForm from "../Mid-Panel/MeetingForm";

interface MeetingDetails {
  meetingId: string | undefined;
  eId: string | undefined;
  email: string | undefined;
  startTime: string | undefined;
  endTime: string | undefined;
}

export default function FeedbackAppTab() {
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const [error, setError] = useState<string>();
  const [divShow, setdivShow] = useState(false);
  const [divForceShow, setForcedivShow] = useState(false);
  const [showConfigPage, setShowConfigPage] = useState(false);
  const [showRemovePage, setShowRemovePage] = useState(false);
  const [showMessagePopup, setShowMessagePopup] = useState(false);
  const [msgLoadDetails, setMsgLoadDetails] = useState<Msgdetails | null>(null);
  const [appInfo, setAppInfo]: any = useState();
  const [showMeeting, setShowMeeting] = useState<boolean>(false);
  const [midPanle, setMidPanel] = useState<boolean>(false);
  const [meetingDetails, setMeetingDetails] = useState<MeetingDetails>({
    meetingId: undefined,
    eId: undefined,
    email: undefined,
    startTime: undefined,
    endTime: undefined,
  });

  useEffect(() => {
    (async () => {
      try {
        setShowLoader(true);
        await microsoftTeams.app.initialize();
        const token = await microsoftTeams.authentication.getAuthToken();
        const decoded: { [key: string]: any } = jwtDecode(token) as {
          [key: string]: any;
        };
        console.log("****token", token);
        console.log("****auth_decoded", decoded);
        sessionStorage.setItem("authMech", "SSO");
        setdivShow(true);
        setForcedivShow(false);
        setError("");
        const ctx = await microsoftTeams.app.getContext();
        console.log("****context", ctx);
        setAppInfo(ctx);
        if (ctx.meeting === undefined && ctx.chat === undefined) {
          setMidPanel(true);
        } else {
          const data = await new Promise<any>((resolve, reject) => {
            try {
              microsoftTeams.meeting.getMeetingDetails((err, d) =>
                err ? reject(err) : resolve(d)
              );
            } catch (e) {
              console.error("Error calling getMeetingDetails:", e);
              reject(e);
            }
          });
          console.log("****meeting_details", data);
          const details: MeetingDetails = {
            meetingId: ctx?.meeting?.id,
            email:
              decoded?.userPrincipalName ||
              decoded?.preferred_username ||
              undefined,
            eId: decoded?.personnelNumber || undefined,
            startTime:
              toLocalDateTimeWithZ(data?.details.scheduledStartTime) ||
              undefined,
            endTime:
              toLocalDateTimeWithZ(data?.details.scheduledEndTime) || undefined,
          };
          setMeetingDetails(details);
          setShowMeeting(true);
        }
        microsoftTeams.app.notifySuccess();
      } catch (error: any) {
        console.error("Initialization/Auth/Context error: ", error);
        setError("SSO not working");
        window.localStorage.clear();
        setdivShow(false);
        setForcedivShow(true);
        setShowMeeting(false);
        microsoftTeams.app.notifyFailure({
          reason: error?.reason || microsoftTeams.app.FailedReason.AuthFailed,
          message: error?.message || String(error),
        });
      } finally {
        setShowLoader(false);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        await microsoftTeams.app.initialize();
      } catch (e) {
        console.log("errror initializing meeting in details effect block", e);
      }
    })();
  }, []);

  useEffect(() => {
    if (appInfo?.page?.frameContext == "sidePanel") {
      setShowLoader(false);
      setdivShow(true);
      setShowConfigPage(false);
      setShowRemovePage(false);
      console.log("InMeeting joined");
    } else if (appInfo?.page?.frameContext == "settings") {
      setShowLoader(false);
      setdivShow(false);
      setShowConfigPage(true);
      setShowRemovePage(false);
    } else if (appInfo?.page?.frameContext == "remove") {
      setShowLoader(false);
      setdivShow(false);
      setShowConfigPage(false);
      setShowRemovePage(true);
    } else {
      setShowLoader(false);
      setShowConfigPage(false);
      setShowRemovePage(false);
    }
  }, [appInfo]);

  function showUserInformationUsingForceLogin() {
    microsoftTeams.authentication
      .authenticate({
        url:
          import.meta.env.VITE_START_LOGIN_PAGE_URL +
          "?clientId=" +
          import.meta.env.VITE_CLIENT_ID +
          "&scope=" +
          import.meta.env.VITE_AAD_SCOPE +
          "&loginHint=" +
          appInfo.user?.userPrincipalName,
        width: 600,
        height: 535,
      })
      .then((res) => {
        // console.log("AuthenticateRes", res);
        microsoftTeams.authentication
          .getAuthToken({
            resources: [import.meta.env.VITE_API_SCOPE],
            silent: true,
          })
          .then((token) => {
            const decoded: { [key: string]: any } = jwtDecode(token) as {
              [key: string]: any;
            };
            console.log(token);
            sessionStorage.setItem("authMech", "Forced");
            setdivShow(true);
            setForcedivShow(false);
            setError("");
            microsoftTeams.app.notifySuccess();
          })
          .catch((error: any) => {
            console.log("Token Error ", error);
            setError("SSO not working");
            window.localStorage.clear();
            setdivShow(false);
            setForcedivShow(true);
            microsoftTeams.app.notifyFailure({
              reason: microsoftTeams.app.FailedReason.AuthFailed,
              message: error as string,
            });
          });
      })
      .catch((err) => {
        console.log("AuthenticateErr", err);
        if (err.toString().includes("FailedToOpenWindow")) {
          window.alert("Enable Popup and click Forced Login Button");
        }
        setError("SSO not working " + err.toString());
        setdivShow(false);
        setForcedivShow(true);
        microsoftTeams.app.notifyFailure({
          reason: microsoftTeams.app.FailedReason.Timeout,
          message: error as string,
        });
      });
  }

  const toLocalDateTimeWithZ = (utcString?: string) => {
    if (!utcString) return undefined;

    // Parse the UTC string
    const date = new Date(utcString);

    // Get local year, month, day, hours, minutes
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0"); // local hours
    const minutes = String(date.getMinutes()).padStart(2, "0"); // local minutes

    // Return with trailing Z
    return `${year}-${month}-${day}T${hours}:${minutes}:00.000Z`;
  };

  return (
    <div>
      {
        <div>
          {error && (
            <div>
              <p>{` ${
                divForceShow
                  ? `Oops!! Something went wrong, please try Forced Login. Error:`
                  : ``
              }   ${error}`}</p>
            </div>
          )}
          {divForceShow && (
            <div className="div-forcelogin">
              <button
                id="btnSSO"
                className="btn-forcelogin"
                content="Forced Login"
                onClick={() => showUserInformationUsingForceLogin()}
              >
                Forced Login
              </button>
            </div>
          )}
          {divShow && !showConfigPage && !showRemovePage && (
            <div className="app-container">
              {!showLoader && !showMessagePopup && showMeeting && (
                <InMeetingNew1Tab
                  MeetingDetails={meetingDetails}
                ></InMeetingNew1Tab>
              )}
              {midPanle && <MeetingForm />}
              {showMessagePopup && msgLoadDetails && (
                <MessagePopup msgdetails={msgLoadDetails}></MessagePopup>
              )}
              {showLoader && !showMeeting && (
                <div>
                  <img className="loader" src="/assets/loader.gif"></img>
                </div>
              )}
            </div>
          )}
          {showConfigPage && <FeedbackAppTabConfig></FeedbackAppTabConfig>}
          {showRemovePage && <FeedbackAppTabRemove></FeedbackAppTabRemove>}
        </div>
      }
    </div>
  );
}
